/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { TTableColumnCell } from '@modules/table/types';

import { TextDoubleStyled, TextDoubleSubtitleStyled } from '../styled/TableCellTextDoubleStyled';
import TableCell from '../TableCell';
import TableCellNoValue from '../TableCellNoValue';
import { TTableCellTextDouble } from './types';

export function TableCellTextDouble<D extends object>(cell: TTableCellTextDouble<D>): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const { title, subTitle } = cell(row);
                if (!!title) {
                    return (
                        <TextDoubleStyled>
                            <span className='table__tooltip-text'>{title}</span>
                            <TextDoubleSubtitleStyled className='table__tooltip-text'>{subTitle}</TextDoubleSubtitleStyled>
                        </TextDoubleStyled>
                    )
                }
                return <TableCellNoValue />;
            },
        }),
    };
}
